import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-feature-cards',
  imports: [RouterModule],
  templateUrl: './feature-cards.html',
  styleUrl: './feature-cards.scss',
})
export class FeatureCards {
  environment = environment;
  feature = environment.FeatureConfig;
}
